import initContentReadingTracking from '../../../analytics/src/datalayer-content-reading-tracking';

export const regWallDisplayed = messageParts => {
	if ( dataLayer ) {
		dataLayer.push( {
			event: 'regwall',
			event_action: 'impression',
			event_label: messageParts[ 1 ],
			piano_label: messageParts[ 1 ],
		} );
	}

	window.paywallDisplayed = 'registration';

	const regWallDisplayedEvent = new CustomEvent( 'regWallDisplayed' );
	window.dispatchEvent( regWallDisplayedEvent );

	if ( 'RTA' in window ) {
		window.RTA.updateReport( { paywallStatus: 'isRestricted' } );
	}

	let modalFrame = null;

	const docRoot = document.querySelector( '.article__content' );
	const pianoFrame = docRoot.querySelector( window.PIANO_ID_MESSAGE_ORIGIN_SELECTOR );
	const modal = document.querySelector( '.tp-modal' );
	if ( modal ) {
		modalFrame = modal.querySelector( window.PIANO_ID_MESSAGE_ORIGIN_SELECTOR );
	}

	if ( window.PIANO_ID_MESSAGE_ORIGIN_SELECTOR ) {
		const targetPath = new URL( top.location.href ).pathname;
		if ( pianoFrame ) {
			pianoFrame.contentWindow.postMessage(
				'reg-wall-target-path|' + targetPath,
				window.PIANO_ID_MESSAGE_ORIGIN,
			);
		} else if ( modalFrame ) {
			modalFrame.contentWindow.postMessage(
				'reg-wall-target-path|' + targetPath,
				window.PIANO_ID_MESSAGE_ORIGIN,
			);
		}
	}

	const pianoContainer = docRoot.querySelector( '.tp-container-inner' );
	if ( pianoContainer ) {
		if ( window.geoSpecifics ) {
			window.geoSpecifics.init();
		}
		const regWallContainer = pianoContainer.parentElement;
		regWallContainer.classList.add( 'js-reg-wall-container' );
		const containingElement = regWallContainer.parentElement;
		containingElement.id = 'js-paragraph-fade-after';
		const childNodes = Array.prototype.slice.call( containingElement.childNodes );
		let startRemove = false;
		for ( let i = 0; i < childNodes.length; i ++ ) {
			const node = childNodes[ i ];
			if ( node.nodeType === Node.ELEMENT_NODE ) {
				if ( node.classList.contains( 'js-reg-wall-container' ) ) {
					startRemove = true;
					continue;
				}
			}
			if ( startRemove ) {
				containingElement.removeChild( node );
			}
		}
	}

	if ( typeof suspended_refresh_call !== 'undefined' ) {
		window.clearTimeout( suspended_refresh_call );
		const contentAds = docRoot.querySelectorAll( '.AdvertWrapper' );
		contentAds.forEach( function ( contentAd ) {
			contentAd.style.display = 'none';
		} );
	}

	if ( ! modal ) {
		initContentReadingTracking();
	}
};

export default regWallDisplayed;
